$(document).ready(function() {


 setTimeout(function() {
$('.checkbox_main .checkbox_wrapper').click();
 },200);

$('.checkbox_main .checkbox_wrapper, .custom-checkboxxx').on('click', function() {
$('.chk_bx_wrapper .custom-checkboxxx').toggleClass('checked');
$(this).toggleClass('checked');
if ($('.custom-checkboxxx').hasClass('checked')) {

var price_dataa = $('.product-price-container').attr('price');
var compare_data = $('.product-price-container').attr('compared_price_data');
var price_new = $('.product-price-container').attr('price_new');

console.log(price_dataa);
console.log(compare_data);
let firstVarId = $('.preoducts_wrapper_all').eq(0).attr('var_id');
let firstVarPrice = $('.preoducts_wrapper_all').eq(0).attr('var_price');
let firscomVarPrice = parseFloat($('.preoducts_wrapper_all').eq(0).attr('var_main_price'));
let firsmaincomVarPrice = $('.preoducts_wrapper_all').eq(0).attr('var_maain_compar_price');
var currency = $('.preoducts_wrapper_all').attr('currency');
let firstVarId_discount = parseFloat($('.preoducts_wrapper_all').eq(0).attr('discounted_price'));
let secondVarId_discount = parseFloat($('.preoducts_wrapper_all').eq(1).attr('discounted_price'));

firstVarId_discount = Math.round(firstVarId_discount * 10) / 10;
secondVarId_discount = Math.round(secondVarId_discount * 10) / 10;

console.log('firstVarId_discount', firstVarId_discount.toFixed(2)); 
console.log('secondVarId_discount', secondVarId_discount.toFixed(2)); 


let secondVarId = $('.preoducts_wrapper_all').eq(1).attr('var_id');
let secondVarPrice = $('.preoducts_wrapper_all').eq(1).attr('var_price');
let secondcomVarPrice = parseFloat($('.preoducts_wrapper_all').eq(1).attr('var_main_price'));
let secondmaincomVarPrice = $('.preoducts_wrapper_all').eq(1).attr('var_maain_compar_price');
var priec_dataaa = parseFloat($('.product-price-container').attr('compared_price_data')) || 0;
// console.log("Sum of first and second com var prices: ", firscomVarPrice.toFixed(2));
// console.log("Sum of first and second com var prices: ", secondcomVarPrice.toFixed(2));
let add_prices = priec_dataaa + firstVarId_discount + secondVarId_discount;
let final_price = currency + add_prices.toFixed(2);
console.log("Sum of first and second com var prices: ", currency + add_prices.toFixed(2));
$('.oma-ballistic-backpack .product-price-container span.price ins').after('<div class="new_daaatta_newww"><span style="padding-left:20px; text-decoration: line-through; color: #5b5757;" class="amount">$489.97</span></div>');
if ($('body').hasClass('oma-ballistic-backpack')) {
   
}else{
 $('.product-price-container span.amount.discounted_data').text(final_price);
}


let inputValue1 = firstVarId;
let inputValue2 = secondVarId;

var html = '<div class="var_datta_all">' +
'<input type="hidden" name="items[1][id]" value="' + inputValue1 + '">' +
'<input type="hidden" name="items[1][quantity]" value="1">' +
'<input type="hidden" name="items[2][id]" value="' + inputValue2 + '">' +
'<input type="hidden" name="items[2][quantity]" value="1">' +
'</div>';
$('.selected_varients_wrp').html(html);
} else {
var price_new = $('.product-price-container').attr('price_new');
$('.product-price-container span.amount.discounted_data').text(price_new);
$('.new_daaatta_newww').remove();
$('.var_datta_all').remove();
}



});







// new_add to cart//
setTimeout(function(){

$('.variations .product-form__input--block    input[name="Size"], .variations .product-form__input--block input[name="Waist Size"]').each(function() {
    if ($(this).is(':checked')) {
        InputValue = $(this).val();
$('.new_cart_btn.single-add-to-cart-button.button').attr('var_size', InputValue);
    }
});

 var selectedVarId = $('input[name="belt-option"]:checked').closest('.option').attr('var_id');
  // alert('Initial selected var_id:', selectedVarId);
  $('.new_cart_btn').attr('varr_id',selectedVarId);
  $('.option').removeClass('boder_datat');
  $('input[name="belt-option"]:checked').closest('.option').addClass('boder_datat');
  var comp_price =  $('input[name="belt-option"]:checked').closest('.option').attr('comp_price');
  var ori_price  = $('input[name="belt-option"]:checked').closest('.option').attr('ori_price');
comp_price = comp_price || ''; 
ori_price = ori_price || '';

   $('.price_datta.new.price span.comp_price').text(comp_price);
   $('.price_datta.new.price span.ori_price').text(ori_price);



},800);

$('input[name="belt-option"]').change(function() {
    var selectedVarId = $(this).closest('.option').attr('var_id');
 $('.option').removeClass('boder_datat');
    $(this).closest('.option').addClass('boder_datat');
    console.log('Selected var_id:', selectedVarId);
    $('.new_cart_btn').attr('varr_id',selectedVarId);


var selectedVarId = $(this).closest('.option').attr('var_id');
    var ori_price = $(this).closest('.option').attr('ori_price');
    var comp_price = $(this).closest('.option').attr('comp_price');
comp_price = comp_price || ''; 
ori_price = ori_price || '';
// alert(comp_price);
// alert(ori_price);
   $('.price_datta.new.price span.comp_price').text(comp_price);
   $('.price_datta.new.price span.ori_price').text(ori_price);
    if (!ori_price) {
        ori_price = $(this).closest('.option').attr('product_main_price');
          $('.product-price-container span.amount.discounted.discounted_data').text(ori_price);
   $('.price_datta.new.price span.ori_price').text(ori_price);
 
    }

    if (!comp_price) {
        comp_price = $(this).closest('.option').attr('product_comppain_price');
           $('.product-price-container span.amount.newwwww.original_price_daata').text(comp_price);
   $('.price_datta.new.price span.comp_price').text(comp_price);
    }

    







});








$('.new_cart_btn').click(function() {
  
    if ($('.main-container .option.omnicarry-belt, .option_two_for_new').hasClass('boder_datat')) {

var InputValue;
$('.variations .product-form__input--block input[name="Size"], .variations .product-form__input--block input[name="Waist Size"]').each(function() {
    if ($(this).is(':checked')) {
        InputValue = $(this).val().split(' ')[0];
    }
});

console.log('Checked input value:', InputValue);

if (InputValue === 'S') {
    var varId = $('.option.omnicarry-belt.boder_datat, .option_two_for_new').attr('var_id');
    // alert(varId);
} else if (InputValue === 'M' || InputValue === 'L') {
    var varId = $('.option.omnicarry-belt.boder_datat, .option_two_for_new').attr('var_id2');
    // alert(varId);
} else if (['XL', '2XL', '3XL'].includes(InputValue)) {
    var varId = $('.option.omnicarry-belt.boder_datat, .option_two_for_new').attr('var_id3');
    // alert(varId);
}

    }else{
  var varId = $(this).attr('varr_id'); 
        
    }
    

    if (varId) {
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                id: varId, 
                quantity: 1 
            },
            dataType: 'json',
            success: function(response) {
                $('.main_cart_btn').click();
            },
            error: function(xhr, status, error) {
                console.error('Error adding to cart:', error);
            }
        });
    } else {

        $('.main_cart_btn').click();
    }
});




 $(".two-belt-options-2025-update").on("click", function() {


    
 });



// onload code//

var new_data = $('.option.standard-belt').attr('var_id');

$(".option.omnicarry-belt").each(function () {
    var var_id = $(this).attr("var_id");
    var var_id2 = $(this).attr("var_id2");
    var var_id3 = $(this).attr("var_id3");

    var all_var_ids = [new_data, var_id, var_id2, var_id3];

    console.log("All var_ids:", all_var_ids);

    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            var cartVariantIds = cart.items.map(item => item.id.toString()); 

            if (all_var_ids.some(id => cartVariantIds.includes(id))) {
                $('#apparel-only').prop('checked', true);
                $('.option').removeClass('boder_datat');
                $('.option.apparel-only').addClass('boder_datat');
             
            }
        })
        .catch(error => console.error("Error fetching cart:", error));
});






});









/* Track cookie banner height so the sticky Add to Cart bar can sit above it */
(function () {
  function set(h) { document.documentElement.style.setProperty('--pc-banner-h', h + 'px'); }
  function watch(b) {
    var upd = function () { set(!b.isConnected || getComputedStyle(b).display === 'none' ? 0 : b.offsetHeight); };
    upd();
    new MutationObserver(upd).observe(b, { attributes: true, attributeFilter: ['style', 'class'] });
    if (window.ResizeObserver) new ResizeObserver(upd).observe(b);
    document.addEventListener('visitorConsentCollected', function () { set(0); });
  }
  var tries = 0, t = setInterval(function () {
    var b = document.getElementById('shopify-pc__banner');
    if (b) { clearInterval(t); watch(b); } else if (++tries > 40) clearInterval(t);
  }, 250);
})();